import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";

export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "customerJourneyName",
    numeric: false,
    disablePadding: true,
    label: "Journey Name",
  },
  // {
  //   id: "description",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Description",
  // },
  {
    id: "activeStatus",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
export const LeadBulkuploadForm = [
  {
    tag: InputBox,
    label: "Upload Leads",
    type: "file",
    key_name: "file",
  },
];
